export const asaasStatusPtbr = (status) => {
  if (!status) return null
  const s = String(status).toUpperCase()

  const map = {
    // subscription status (assinaturas)
    ACTIVE: 'Ativa',
    PENDING: 'Pendente',
    INACTIVE: 'Inativa',
    EXPIRED: 'Expirada',

    PENDING: 'Pendente',
    RECEIVED: 'Recebido',
    CONFIRMED: 'Confirmado',
    OVERDUE: 'Vencido',
    REFUNDED: 'Reembolsado',
    RECEIVED_IN_CASH: 'Recebido em dinheiro',
    REFUND_REQUESTED: 'Reembolso solicitado',
    CHARGEBACK_REQUESTED: 'Chargeback solicitado',
    CHARGEBACK_DISPUTE: 'Em disputa (chargeback)',
    AWAITING_CHARGEBACK_REVERSAL: 'Aguardando reversão do chargeback',
    DUNNING_REQUESTED: 'Cobrança solicitada',
    DUNNING_RECEIVED: 'Cobrança recebida',
    AWAITING_RISK_ANALYSIS: 'Aguardando análise',
    CANCELLED: 'Cancelado',
  }

  return map[s] || status
}

